module.exports = __webpack_public_path__ + "img/arrow-right-to-line.d963aaea.svg";